module.exports = __webpack_public_path__ + "static/media/Logo.2af00ff9.png";